import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { UI } from "../../../services/ui.service";
import { PopOverComponent } from "../../pop-over/pop-over.component";
import { SecEventsService } from "../expandable/sec-events.service";
import { SignalStandardType } from "../../../domain/signal-standard-type";

@Component({
  selector: "evrideo-marker-popover",
  templateUrl: "./marker-popover.component.html",
  styleUrls: ["./marker-popover.component.scss"],
})
export class MarkerPopoverComponent implements OnInit {
  @ViewChild("popup", { static: true }) popup: PopOverComponent;

  markerNameInputIsRequired = false;
  signalDurationInputIsRequired = false;
  chooseMarkerTypeScreenShown = true;
  newSCTEMarkerScreenShown = false;
  newDTMFMarkerScreenShown = false;

  checkoutForm = this.formBuilder.group({
    markerName: "",
    outCode: "",
    inCode: "",
    duration: "",
    volume: "",
    language: "",
    signalDuration: "",
    signalDelta: "",
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private ui: UI,
    private secEventsService: SecEventsService,
  ) {}

  ngOnInit(): void {}

  showPopup(e: MouseEvent): void {
    this.popup.toggle(e);
  }

  hidePopup(): void {
    this.popup.hide();
    this.chooseMarkerTypeScreenShown = true;
    this.newSCTEMarkerScreenShown = false;
    this.checkoutForm.reset();
    this.newDTMFMarkerScreenShown = false;
    this.markerNameInputIsRequired = false;
    this.signalDurationInputIsRequired = false;
  }

  async onSubmitSCTE() {
    this.markerNameInputIsRequired = false;
    if (this.checkoutForm.value.markerName < 1) {
      this.markerNameInputIsRequired = true;
    } else {
      try {
        await this.secEventsService.createNewMarker({
          ...this.checkoutForm.value,
          markerType: SignalStandardType.SCTE35,
        });
      } catch (error) {
        console.log(error.message);
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "error adding marker",
          message: error.message,
        });
      }
      this.checkoutForm.reset();
      this.hidePopup();
    }
  }

  async onSubmitDTMF() {
    this.markerNameInputIsRequired = false;
    this.signalDurationInputIsRequired = false;
    if (!this.checkoutForm.value.markerName) {
      this.markerNameInputIsRequired = true;
    }
    if (!this.checkoutForm.value.signalDuration) {
      this.signalDurationInputIsRequired = true;
    }
    if (
      !this.markerNameInputIsRequired &&
      !this.signalDurationInputIsRequired
    ) {
      try {
        await this.secEventsService.createNewMarker({
          ...this.checkoutForm.value,
          markerType: SignalStandardType.DTMF,
        });
      } catch (error) {
        console.log(error.message);
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "error adding marker",
          message: error.message,
        });
      }
      this.checkoutForm.reset();
      this.hidePopup();
    }
  }
}
